if (!customElements.get('endless-blog')) {
  class EndlessBlog extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      fetch(this.loadMore.getAttribute('data-url') + '&view=list')
        .then((res) => res.text())
        .then((data) => {
          const parser = new DOMParser().parseFromString(data, 'text/html');
          const endlessBlog = parser.querySelector('endless-blog');

          this.loadMore.replaceWith(
            document
              .createRange()
              .createContextualFragment(endlessBlog.innerHTML),
          );

          this.init();
        })
        .catch((error) => console.log(error));
    }

    init() {
      this.loadMore = this.querySelector('[js-load-more]');

      this.loadMore.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('endless-blog', EndlessBlog);
}
